import React from 'react';
import { CountryDataList } from './CountryDataStyled';
import { Box } from "@mui/material";
import AccordionComp, { Accordion } from "../../utilities/Accordian/Accordian";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import InfoIcon from '@mui/icons-material/InfoOutlined';
const CountryData = ({ country }) => {



    return (
        <CountryDataList className="customerStatus">

            {country.map((countrydata, index) => (

                <Box className="countryList">
                    <AccordionComp title={countrydata.id} aria-required >
                        <h3>Products</h3>
                        
                            <TableContainer component={Paper} className="d-flex">
                                <Table sx={{ minWidth: 400 }} aria-label="customized table">
                                  
                                    <TableBody>
                                        {countrydata.componentList.map((row, rowIndex) => (
                                            <TableRow  key={rowIndex}>
                                                 <TableCell size="small" key={row.id} className='firstrow'>
                                                    <InfoIcon />
                                                   </TableCell>
                                                <TableCell size="small" key={row.id} className="productrow">
                                              {row.componentName}</TableCell>
                                                <TableCell size="small"className="productrow" key={row.id}><Checkbox defaultChecked={row.checked}/></TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                        

                    </AccordionComp>
                </Box>
            ))}
        </CountryDataList>
    );
};

export default CountryData;
